import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f3a955b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-container" }
const _hoisted_2 = { class: "payment-overview-block-wrapper flex-wrapper flex-height" }
const _hoisted_3 = { class: "payment-overview-block" }
const _hoisted_4 = { class: "payment-search-wrapper" }
const _hoisted_5 = { class: "payment-search-row" }
const _hoisted_6 = { class: "search-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Task Period ", -1))
const _hoisted_8 = { class: "search-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Task Status ", -1))
const _hoisted_10 = { class: "search-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Task Name CN ", -1))
const _hoisted_12 = { class: "search-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " Task Category ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-item" }, null, -1))
const _hoisted_15 = { class: "search-btn" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Search ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Create Task ")
const _hoisted_18 = {
  class: "payment-overview-block flex-wrapper flex-height",
  style: {"margin-top":"10px"}
}
const _hoisted_19 = { class: "operation" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_form_modal = _resolveComponent("form-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb, { dataSource: [] }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_a_range_picker, {
                  allowClear: "",
                  value: _ctx.taskPeriod,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.taskPeriod) = $event)),
                  placeholder: ['Start date', 'End date'],
                  format: _ctx.dateFormat
                }, null, 8, ["value", "format"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_a_select, {
                  value: _ctx.taskStatus,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.taskStatus) = $event)),
                  class: "sel-inp-size",
                  placeholder: "Please select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_a_input, {
                  placeholder: "Please input",
                  value: _ctx.taskNameCn,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.taskNameCn) = $event)),
                  allowClear: ""
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_a_select, {
                  value: _ctx.category,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.category) = $event)),
                  class: "sel-inp-size",
                  placeholder: "Please select"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _hoisted_14
            ]),
            _createElementVNode("div", _hoisted_15, [
              (_ctx.$btnPermissions('RV Distribution Search'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "m-r-15",
                    onClick: _ctx.search
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.$btnPermissions('RV Distribution Add'))
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    onClick: _ctx.handleAdd
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_table_wrapper, { "is-pagination": _ctx.isPagination }, {
            default: _withCtx((slotProps) => [
              _createVNode(_component_a_table, {
                scroll: { y: slotProps.tableHeight, x: 1600 },
                dataSource: _ctx.data,
                columns: _ctx.column,
                rowKey: "id",
                pagination: false,
                rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
              }, {
                operation: _withCtx(({ record }) => [
                  _createElementVNode("div", _hoisted_19, [
                    (record.taskStatus !== '3' && _ctx.$btnPermissions('RV Distribution Edit'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "link",
                          onClick: ($event: any) => (_ctx.handleEdit(record))
                        }, "Edit", 8, _hoisted_20))
                      : _createCommentVNode("", true),
                    (_ctx.$btnPermissions('RV Distribution Details'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "link",
                          onClick: ($event: any) => (_ctx.handleToDetail(record))
                        }, "Details", 8, _hoisted_21))
                      : _createCommentVNode("", true),
                    (_ctx.$btnPermissions('RV Distribution Delete'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "link",
                          onClick: ($event: any) => (_ctx.handleDelete(record))
                        }, "Delete", 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["scroll", "dataSource", "columns", "rowClassName"])
            ]),
            _: 1
          }, 8, ["is-pagination"])
        ])
      ])
    ]),
    _createVNode(_component_form_modal, {
      visible: _ctx.formModalVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formModalVisible) = $event)),
      "form-type": _ctx.formType,
      "cur-row": _ctx.curRow,
      "date-format": _ctx.dateFormat,
      onOnConfirm: _ctx.search
    }, null, 8, ["visible", "form-type", "cur-row", "date-format", "onOnConfirm"])
  ], 64))
}